module.exports = __webpack_public_path__ + "img/ic-ig.d4c56371.svg";